module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"followToRead":"Folgen zum Lesen"},"en":{"followToRead":"Follow to read"}}')
  delete Component.options._Ctor
}
